import { useNavigate } from "react-router-dom";
import { ExpensesHome } from "@/components/ExpensesHome";

export function ExpensesHomePage() {
  const navigate = useNavigate();
  return (
    <ExpensesHome
      onOpenExpenses={(tab, cardId) => {
        const params = new URLSearchParams();
        if (tab) params.set("tab", tab);
        if (cardId) params.set("card", cardId);
        const query = params.toString();
        navigate(query ? `/expenses?${query}` : "/expenses");
      }}
      onOpenMerchant={(id) => navigate(`/expenses/merchants/${id}`)}
      onLinkCard={() => navigate("/cards")}
    />
  );
}
